import { render } from "./EditVat.vue?vue&type=template&id=449714b6"
import script from "./EditVat.vue?vue&type=script&lang=js"
export * from "./EditVat.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__